import { render } from "./WidgetBmfwfSeiteMerken.vue?vue&type=template&id=ffd2724c&scoped=true&ts=true"
import script from "./WidgetBmfwfSeiteMerken.vue?vue&type=script&lang=ts"
export * from "./WidgetBmfwfSeiteMerken.vue?vue&type=script&lang=ts"

import "./WidgetBmfwfSeiteMerken.vue?vue&type=style&index=0&id=ffd2724c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd2724c"]])

export default __exports__